var footerPublic = {
    connect:"CONNECT",
    news:"",
    go:"GO",
    welcome:"Welcome",
    rewards:"Rewards",
    registeragent:"Agent Register",
    registeragency:"Agency Register",    
    login:"Login",
    lang:"Español",
    contact:"Contact us",
    copyright:"© 2023 Marival Resorts for Travel Agents. All Rights Reserved.",
    cookiePolicy:"Cookie Policy",
    privacyPolicy:"Privacy policy"

}
module.exports = footerPublic
